import { customBaseUrl, httpGet, httpPost, httpPut, httpDelete } from "../../store/http";

const { commissionUrl } = customBaseUrl;

// Commission Types
export const getCommissionTypes = async () => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/types`);
};

export const createCommissionType = async (payload) => {
    return await httpPost(`${commissionUrl}/api/v1/admin/commissions/types`, payload);
};

export const updateCommissionType = async (id, payload) => {
    return await httpPut(`${commissionUrl}/api/v1/admin/commissions/types/${id}`, payload);
};

export const deleteCommissionType = async (id) => {
    return await httpDelete(`${commissionUrl}/api/v1/admin/commissions/types/${id}`);
};

export const toggleCommissionTypeStatus = async (id) => {
    return await httpPut(`${commissionUrl}/api/v1/admin/commissions/types/${id}/toggle-status`, {});
};

export const validateCommissionCode = async (code) => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/types/validate-code/${code}`);
};

export const getCommissionTypeByCode = async (code) => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/types/code/${code}`);
};

export const getCommissionTypesByCategory = async (category) => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/types/category/${category}`);
};

// Commission Configurations
export const getCommissionConfigurations = async () => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/configurations`);
};

export const getCommissionConfigById = async (id) => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/configurations/${id}`);
};

export const createCommissionConfig = async (payload) => {
    return await httpPost(`${commissionUrl}/api/v1/admin/commissions/configurations`, payload);
};

export const updateCommissionConfig = async (id, payload) => {
    return await httpPut(`${commissionUrl}/api/v1/admin/commissions/configurations/${id}`, payload);
};

export const deleteCommissionConfig = async (id) => {
    return await httpDelete(`${commissionUrl}/api/v1/admin/commissions/configurations/${id}`);
};

export const toggleCommissionConfigStatus = async (id) => {
    return await httpPut(`${commissionUrl}/api/v1/admin/commissions/configurations/${id}/toggle-status`, {});
};

export const getConfigsByTypeId = async (typeId) => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/configurations/type/${typeId}`);
};

export const getConfigsByCode = async (code) => {
    return await httpGet(`${commissionUrl}/api/v1/admin/commissions/configurations/code/${code}`);
};
